import { PageRequest } from './../../../../models/pagination/page-request';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ScoreInputForm } from '@models/clash/scoreboard/score-input-form';
import { ScoredboardDto } from '@models/clash/scoreboard/scoreboard-dto';
import { ScoredboardForm } from '@models/clash/scoreboard/scoreboard-form';
import { ResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { BaseService } from '@shared/services/base-service';
import { Observable } from 'rxjs';
import { toParams } from 'src/app/core/utilities/utility-functions';

@Injectable({
  providedIn: 'root'
})
export class ScoreboardService extends BaseService {
  urlApi = environment.apiUrl + '/v1/placar';

  listScoreOfAFight(embNrId: number, pageable?: PageRequest): Observable<ResponseDto<IPage<ScoredboardDto>>> {
    let params = toParams({ pageable: pageable, embNrId });
    return this.http.get<ResponseDto<IPage<ScoredboardDto>>>(this.urlApi, { params });
  }

  registerScoreOfAPeriod(form: ScoreInputForm): Observable<ResponseDto<ScoredboardDto[]>> {
    return this.http.post<ResponseDto<ScoredboardDto[]>>(this.urlApi, form );
  }

  declareWOInAPeriod(iemNrId: number, vencedor: boolean): Observable<ResponseDto<ScoredboardDto[]>> {
    let params = toParams(iemNrId, vencedor)
    return this.http.post<ResponseDto<ScoredboardDto[]>>(this.urlApi + `/declarar-wo`, null, { params });
  }
  resetScoreBoard(embNrId:number):Observable<ResponseDto<void>>{
    return this.http.delete<ResponseDto<void>>(`${this.urlApi}/${embNrId}/resetar`);
  }
}
